/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface VoucherConsegnaSummaryDTO { 
    /**
     * Voucher passati ad DA_CONSUMARE con comunicazione dispatchata
     */
    consegnati?: number;
    /**
     * Voucher già oltre ASSEGNATO (no-op)
     */
    gia_consegnati?: number;
    /**
     * Numero totale di voucher del bando processati
     */
    totali?: number;
}

